/* eslint-disable react-hooks/rules-of-hooks */
import React, { Fragment } from 'react';
import { useImage } from '../hooks/useImage';

const ImageElement = () => {
	const {
		maxHeight,
		maxWidth,
		alt,
		width,
		height,
		minHeight,
		minWidth,
		src,
		srcSet = '',
		title,
		sizes = '',
		blockClass,
		link,
		componentId,
	} = useImage();

	const renderStyles = () => {
		const x = {
			maxHeight,
			maxWidth,
			height,
			width,
			minHeight,
			minWidth,
		};
		//filter out zero values
		Object.keys(x).forEach((key) => x[key] === 0 && delete x[key]);
		return x;
	};

	const imageElement = (
		<img
			data-selection={componentId}
			className={`imageElement ${blockClass ? `imageElement--${blockClass} vtex-store-components-3-x-imageElement--${blockClass}` : ''} vtex-store-components-3-x-imageElement`}
			style={renderStyles()}
			alt={alt}
			src={src}
			srcSet={srcSet}
			title={title}
			sizes={sizes}
		/>
	);

	if (link) {
		return (
			// eslint-disable-next-line jsx-a11y/anchor-is-valid
			<a
				data-selection={componentId}
				className={`imageElementLink ${blockClass ? `imageElementLink--${blockClass} vtex-store-components-3-x-imageElementLink--${blockClass}` : ''} vtex-store-components-3-x-imageElementLink`}
				title={title}
				href={link?.url}
				rel={link?.attributeNofollow === true ? 'noFollow' : ''}
				target={link?.newTab === true ? '_blank' : ''}
				style={{ cursor: 'unset' }}
			>
				{imageElement}
			</a>
		);
	}
	return <Fragment>{imageElement}</Fragment>;
};

export default ImageElement;
